
import { defineComponent, ref } from "vue"

// 查询订单信息
export default defineComponent({
    name: "ExpressDialog",
    props: {
        data: {
            type: Object,
            default: undefined,
        },

    },
    setup(props, { emit }) {
        const info = ref<OrderExpressRsp>()
        const isShow = ref(false)
        const data = props.data
        info.value = JSON.parse(JSON.stringify(data));

        const onCancel = () => {
            isShow.value = false
            emit('result', undefined)
        }
        const clickItem = (mobile: MobileItem) => {
            isShow.value = false
            emit('result', mobile)
        }
        return {
            isShow,
            info,
            onCancel,
            clickItem,
        };
    },
})
